export default {
  acceleratorTeam: {},
  reportParams: {},
  isLoading: false,
  errors: null,
};
